// extracted by mini-css-extract-plugin
module.exports = {"footerCopy":"_3JURW3fq6fcGwXvWFxMC68","footerAction":"_2RJQdbDQqsu2YDqHlXKxAP"};